var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"color":"#D4CECD","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.save}},[_vm._v("\n  add\n")])}
var staticRenderFns = []

export { render, staticRenderFns }